import React, { useEffect, useState } from "react";

import SkeletonLoader from "~/atoms/SkeletonLoader";

interface ProgressBarProps {
  value: number;
  max: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ value, max }) => {
  const percentage = Math.round((value / max) * 100);

  return (
    <>
      <div className="mb-1 flex justify-between">
        <span className="text-xs leading-5 font-medium text-gray-500">
          Progress
        </span>
        <span className="text-xs leading-5 font-medium text-gray-500">
          {percentage}%
        </span>
      </div>
      <div className="h-1.5 w-full rounded-full bg-gray-200">
        <div
          className="h-1.5 rounded-full bg-blue-600 transition-all duration-200 ease-in-out"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </>
  );
};

export const ProgressBarGhost: React.FC = () => (
  <>
    <div className="mb-1 flex justify-between">
      <SkeletonLoader width="50px" height="20px" />
      <SkeletonLoader width="25px" height="20px" />
    </div>
    <div className="h-1.5 w-full rounded-full">
      <SkeletonLoader width="100%" height="100%" />
    </div>
  </>
);

export const ProgressBarAlt: React.FC<ProgressBarProps> = ({ value, max }) => {
  const percentage = Math.round((value / max) * 100);

  const [currentPercentage, setCurrentPercentage] = useState<number>(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentPercentage(percentage);
    }, 100); // delay of 100ms

    // Cleanup function to clear the timeout if the component unmounts
    return () => clearTimeout(timer);
  }, [percentage]);

  return (
    <>
      <div className="mb-1 flex justify-between">
        <span className="text-xs leading-5 font-medium text-gray-500">
          {currentPercentage}%
        </span>
        <span className="text-xs leading-5 font-medium text-gray-500">
          100%
        </span>
      </div>
      <div className="h-1.5 w-full rounded-full bg-gray-200">
        <div
          className="h-1.5 rounded-full bg-blue-600 transition-all duration-200 ease-in-out"
          style={{ width: `${currentPercentage}%` }}
        ></div>
      </div>
    </>
  );
};

export const ProgressBarAltGhost: React.FC = () => (
  <>
    <div className="mb-1 flex justify-between">
      <span className="text-xs leading-5 font-medium text-gray-500">0%</span>
      <span className="text-xs leading-5 font-medium text-gray-500">100%</span>
    </div>
    <div className="h-1.5 w-full rounded-full bg-gray-200">
      <SkeletonLoader width="100%" height="100%" />
    </div>
  </>
);

export default ProgressBar;
